import ValidacaoEspecialidadesServicosPrestadosMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/validation/ValidacaoEspecialidadesServicosPrestadosMixin";
import QuestionarioService from "../../services/QuestionarioService";

export default {
  mixins: [ValidacaoEspecialidadesServicosPrestadosMixin, QuestionarioService],
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      idRnpPrestador: -1,
      especialidadesServicosPrestados: {
        especialidades: "",
        demaisServicos: ""
      }
    };
  },
  beforeMount() {
    this.recuperarIdRnpPrestador();
    this.init();
  },
  methods: {
    init() {
      this.preencheDadosEspecialidadesServicosPrestados();
    },
    recuperarIdRnpPrestador() {
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
    },
    preparaDadosEspecialidadesServicosPrestados() {
      const especialidadesServicosPrestados = {
        ...this.especialidadesServicosPrestados
      };
      return especialidadesServicosPrestados;
    },
    preencheDadosEspecialidadesServicosPrestados() {
      const data = this.$store.getters.getPayloadServidor();
      if (data) {
        if (data.especialidadesServicosPrestados.especialidades) {
          this.especialidadesServicosPrestados.especialidades =
            data.especialidadesServicosPrestados.especialidades;
        }
        if (data.especialidadesServicosPrestados.demaisServicos) {
          this.especialidadesServicosPrestados.demaisServicos =
            data.especialidadesServicosPrestados.demaisServicos;
        }
        if (this.especialidadesServicosPrestados.especialidades) {
          this.errors.especialidades = null;
        }
      }
    }
  }
};
